<template>
  <div class="admin-view">
         <!-- <v-app-bar
        app
        color="indigo"
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Application</v-toolbar-title>
      </v-app-bar> -->
    <LoggedStatus />
    <ul class="actions">  
      <li class="actions__button" @click="currentValue = 'LoginAdmin'">
        Login Admin
      </li>
      <li class="actions__button" @click="currentValue = 'AddAdmin'">
        Add admin
      </li>
      <li class="actions__button" @click="currentValue = 'RegUser'">
        Add User
      </li>
      <li class="actions__button" @click="currentValue = 'UpdateUser'">
        Update User
      </li>
      ™
    </ul>
    <AddAdmin v-if="currentValue == 'AddAdmin'" />
    <LoginAdmin v-if="currentValue == 'LoginAdmin'" />
    <RegisterUser v-if="currentValue == 'RegUser'" />
    <div v-if="currentValue == 'UpdateUser'">
      <UpdateUser v-bind:pickedUser="pickedUser.hash" />
    </div>

    <button class="button" @click="showUsers">show users</button>
<template v-if="users">
<table>
<thead>
</thead>

</table>

  </template>

    <!-- <table v-for="(user) in users.data.users" :key="user"  >
      <tr v-for="person in user" :key="person">
           <td> {{person}}</td> 
           </tr>-->
      
     
     
        <!-- <th>{{key}}</th>
        <th>undefined</th> -->
      
      <!-- <tr >
        <td>{{ user.name }}</td>
        <td>{{ user.surname }}</td>
        <td>{{ user.birthday }}</td>
      </tr> -->
<!--  
    </table> -->

    <template v-if="users">
      <li
        v-for="user in users.data.users"
        :key="user.hash"
        @click="updateSelected(user)"
      >
        {{ user.surname }} {{ user.name }}
      </li></template
    >
    Test:
    {{ pickedUser }}
    {{ pickedUser.name }}
    {{ pickedUser.surname }}
  </div>
</template>

<script>
import AddAdmin from '@/components/AddAdmin.vue';
import firebase from 'firebase/app';
import 'firebase/functions';

export default {
  name: 'Admin',
  components: {
    AddAdmin,
  },
  data() {
    return {
      currentValue: '',
      users: '',
      pickedUser: 'niemand',
      pickedHash: '',
    };
  },
  methods: {
    async showUsers() {
      try {
        const getUsers = firebase.functions().httpsCallable('getUsers');
        const res = await getUsers({ text: 'message' });
        console.log(res);
      } catch (error) {
        this.error = 'incorrect data';
      }
    },
    updateSelected(user) {
      this.pickedUser = user;
      this.pickedHash = user.hash;
      console.log('test');
      console.log(this.pickedUser.hash);
    },
  },
  async created() {
    try {
      const getUsers = firebase.functions().httpsCallable('getUsers');
      const res = await getUsers({ text: 'message' });
      this.users = res;
      console.log(this.users.data.users);
    } catch (error) {
      this.error = 'incorrect data';
    }
  },
};
</script>

<style lang="scss" scoped>
.admin-view {
  justify-content: center;
  background-color: #7dc355;
  height: 100vh;
}

.actions {
  list-style-type: none;
  overflow: hidden;
  text-align: center;

  &__button {
    display: inline-block;
    font-size: 1.2rem;
    font-weight: 600;
    padding-right: 50px;
    &:hover {
      color: #ffee58;
      cursor: pointer;
    }
  }
}
</style>
